// extracted by mini-css-extract-plugin
module.exports = {"circularGauge":"circularGauge_circularGauge__3nZai"};